import {tokens as $} from '@sail/tokens';
import type {Style} from '@sail/engine';
import {useUiConfig} from '../providers/UiConfigProvider';
import {usePartialIframe} from './OverlayOverrides';
import type {TooltipLayerProps} from '../components/Tooltip';
import {css} from '../css';

export const useTooltipIframe = (props: TooltipLayerProps) => {
  const uiConfig = useUiConfig();
  const getUILayers = uiConfig?._unstable_getUILayers;

  const {triggerRef, ...remainingProps} = props;

  const containerStylesTypeDescription = css({
    padding: 'medium',
    maxWidth: '300px',
    backgroundColor: 'surface',
    textColor: 'text',
  });

  const containerStylesTypeLabel = css({
    paddingX: 'small',
    paddingY: 'xsmall',
    maxWidth: '200px',
    textColor: $['color.neutral.0'],
    backgroundColor: $['color.neutral.700'],
  });

  const containerStyles: Style.Intent[] = [
    css({
      font: 'body.small',
    }),
    props.type === 'label'
      ? containerStylesTypeLabel
      : containerStylesTypeDescription,
  ];

  return usePartialIframe({
    ...remainingProps,
    offset: 4,
    targetRef: triggerRef,
    containerStyles,
    uiLayers: getUILayers ? getUILayers() : [],
  });
};
